import React from 'react'



export default function Loader() {
    return (
        <div className='l-spinner'>
            <div className="spinner"></div>
        </div>
    )
}